// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__YCHJf","modal":"Modal_modal__1lnBd","slide-down":"Modal_slide-down__2rqch"};